import InteractionSessionTracking from './interactionSessionTracking';

// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
export const INTERNAL_CLIENT_WINDOW_KEY = 'analyticsInteractionSesssionTrackingClient';

export default class GlobalInteractionSessionTracking {
	static getInstance(): InteractionSessionTracking | undefined {
		let interactionSessionTracking: InteractionSessionTracking | undefined;

		try {
			// Check if InteractionSessionTracking in global window object
			if (INTERNAL_CLIENT_WINDOW_KEY in window) {
				interactionSessionTracking = window[
					INTERNAL_CLIENT_WINDOW_KEY
				] as InteractionSessionTracking;
			} else {
				// Initialise InteractionSessionTracking on global window object
				(window as any)[INTERNAL_CLIENT_WINDOW_KEY] = new InteractionSessionTracking();
				interactionSessionTracking = (window as any)[
					INTERNAL_CLIENT_WINDOW_KEY
				] as InteractionSessionTracking;
			}
		} catch (error) {
			// Silently swallow exception
		}

		return interactionSessionTracking;
	}
}
